/**
* RelytArt
*
* Creative Commons Attribution-NonCommercial-NoDerivatives 4.0 International
* Copyright (c) 2022 RelytArt
*
* License: https://docs.google.com/document/d/1UD7jhCYWRXSxhx4A5vMeGVTjujwLM39BmvjwA0eFFfk/edit?usp=sharing
*
*/

// utils
import PublishSubscribeUtils from "utils/publish-subscribe-utils/PublishSubscribeUtils.js";
import ValidationUtils from "utils/validation-utils/ValidationUtils.js";

class RedirectUtils {
  static lastPathName = null;
  static topicId = PublishSubscribeUtils.createTopic({ name: "RedirectUtils" });

  /**
  * @param {String} fallbackPath
  */
  static back(fallbackPath) {
    const useFallback = (
      !ValidationUtils.string(RedirectUtils.lastPathName) ||
      String(RedirectUtils.lastPathName) === String(window.location.pathname)
    );
    const backPath = useFallback
      ? fallbackPath
      : String(RedirectUtils.lastPathName);
    RedirectUtils.redirect(backPath);
  }

  /**
  * @param {String} redirectPath
  */
  static redirect(redirectPath) {
    RedirectUtils.lastPathName = String(window.location.pathname);
    PublishSubscribeUtils.publish(RedirectUtils.topicId, redirectPath);
  }

  /**
  * @param {Function} onRedirect
  * @returns {String}
  */
  static subscribe(onRedirect) {
    return PublishSubscribeUtils.subscribe(RedirectUtils.topicId, onRedirect);
  }

  /**
  * @param {String} subscriberId
  */
  static unsubscribe(subscriberId) {
    PublishSubscribeUtils.unsubscribe(RedirectUtils.topicId, subscriberId);
  }

}
export default RedirectUtils;
